import { jwtDecode } from "jwt-decode";

export const decryptToken = (encryptedToken) => {
    try {
        const { CostaClickIncentiveResponse } = jwtDecode(encryptedToken);
        return CostaClickIncentiveResponse;
    } catch (error) {
        console.error("Error decrypting token: ", error);
        return null;
    }
};